"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.merlin = void 0;
exports.merlin = {
    "addresses": {
        "ProxyAdmin": "0xF04B152d2E27b5d975A2eb6b7F39EA42A74841Ac",
        "Multicall2": "0x46063722c010AF39E465d286B84936A12aFb81F0",
        "Sumer": "0x553d713e0fB958932b6C40ABAf0b5A1fFae73Da2",
        "CompoundLens": "0x98Ec4C9605D69083089eCAf353037b40017b758e",
        "FeedPriceOracle": "0xddab3eb6028a44Fb31F9Da92eA1608809248B6b3",
        "CompLogic": "0xB2fF02eEF85DC4eaE95Ab32AA887E0cC69DF8d8E",
        "RedemptionManager": "0x8c1ad24cA39FE45E97CD9862364128406E3B03F3",
        "Timelock": "0xA6ae238D9CaF65DFA67670FDE3156EFeE9334488",
        "Comptroller": "0x7465fedB29023d11effe8C74E82A7ecEBf15E947",
        "CErc20": "0x9aa55bCf3E41D0d98FCe816C4eC6E791B0f6d154",
        "suErc20": "0xA2e6B85f9A5C90217054350d7893498B8c892546",
        "JumpRate#StableBC": "0x6116438fD4abDd902dcA8e0335144F700B1a5147",
        "JumpRate#Others": "0x313Ba7E5508e3deb17CD5abA9D7A1b15BdE77879",
        "ZeroRate": "0xe19FD48C972E2dB074C4B0B29Ff2f0d3E1aefe52",
        "sdrM-USDC": "0x8C38b023Afe895296e2598AE111752223185b35c",
        "M-USDC": "0x6b4eCAdA640F1B30dBdB68f77821A03A5f282EbE",
        "sdrM-USDT": "0xb1FdC3f660b0953253141B2509c43014d5d3d733",
        "M-USDT": "0x967aEC3276b63c5E2262da9641DB9dbeBB07dC0d",
        "sdrM-BTC": "0xc7fFEAa5949d50A408bD92DdB0D1EAcef3F8a3Bc",
        "M-BTC": "0xB880fd278198bd590252621d4CD071b1842E9Bcd",
        "sdrSolvBTC": "0x10A2e256Bed7b3c49C151Ad1Bad01F4936FC9276",
        "SolvBTC": "0x41d9036454be47d3745a823c4aacd0e29cfb0f71",
        "sdrsuUSD": "0xf902e1925B50ac70285b73FD065af971487c2E4d",
        "suUSD": "0x8bf591eae535f93a242d5a954d3cde648b48a5a8",
        "sdrsuBTC": "0xdb4d020A58e0A1A67823d75437A61044dC02AE4C",
        "suBTC": "0xe85411C030fB32A9D8b14Bbbc6CB19417391F711"
    },
    "tokenPairs": [
        {
            "ctokenSym": "sdrM-USDC",
            "ctokenAddr": "0x8C38b023Afe895296e2598AE111752223185b35c",
            "underlySym": "M-USDC",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x6b4eCAdA640F1B30dBdB68f77821A03A5f282EbE",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrM-USDT",
            "ctokenAddr": "0xb1FdC3f660b0953253141B2509c43014d5d3d733",
            "underlySym": "M-USDT",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x967aEC3276b63c5E2262da9641DB9dbeBB07dC0d",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrM-BTC",
            "ctokenAddr": "0xc7fFEAa5949d50A408bD92DdB0D1EAcef3F8a3Bc",
            "underlySym": "M-BTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xB880fd278198bd590252621d4CD071b1842E9Bcd",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrSolvBTC",
            "ctokenAddr": "0x10A2e256Bed7b3c49C151Ad1Bad01F4936FC9276",
            "underlySym": "SolvBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x41d9036454be47d3745a823c4aacd0e29cfb0f71",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrsuUSD",
            "ctokenAddr": "0xf902e1925B50ac70285b73FD065af971487c2E4d",
            "underlySym": "suUSD",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x8bf591eae535f93a242d5a954d3cde648b48a5a8",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrsuBTC",
            "ctokenAddr": "0xdb4d020A58e0A1A67823d75437A61044dC02AE4C",
            "underlySym": "suBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xe85411C030fB32A9D8b14Bbbc6CB19417391F711",
            "assetGroupId": 3
        }
    ],
    "rateModels": [
        {
            "name": "JumpRate#StableBC",
            "contract": "JumpRateModelV2",
            "address": "0x6116438fD4abDd902dcA8e0335144F700B1a5147",
            "tokens": [
                "M-USDC",
                "M-USDT"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.09333",
            "jumpMultiplierPerYear": "3.2",
            "kink": "0.75"
        },
        {
            "name": "JumpRate#Others",
            "contract": "JumpRateModelV2",
            "address": "0x313Ba7E5508e3deb17CD5abA9D7A1b15BdE77879",
            "tokens": [
                "M-BTC",
                "SolvBTC"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.15555",
            "jumpMultiplierPerYear": "5.582",
            "kink": "0.45"
        },
        {
            "name": "ZeroRate",
            "contract": "FixedInterestRateModel",
            "address": "0xe19FD48C972E2dB074C4B0B29Ff2f0d3E1aefe52",
            "tokens": [
                "suUSD",
                "suBTC"
            ],
            "initBorrowRate": "0",
            "initSupplyRate": "0"
        }
    ],
    "blocksPerYear": 31536000
};
//# sourceMappingURL=merlin.js.map